<template>
  <div>
    <div v-if="isLogin" class="header">
      <div class="header_top">
        <div class="head" @click="setting()">
          <img :src="this.imgUrl" alt="">
        </div>
        <div class="user_name">
          <p>{{this.$store.state.name}}
            <button @click="logOut">退出</button>
          </p>
        </div>
        <p style="height: .4rem;">{{this.fairDetail.fair_name}}</p>
      </div>
      <div class="order_status">
        <div class="status">
          <p>{{this.countNum.piao}}</p>
          <h2>报名成功</h2>
        </div>
        <div class="status">
          <p>{{this.countNum.qiandao}}</p>
          <h2>已签到</h2>
        </div>
        <div class="status">
          <p>{{this.countNum.order}}</p>
          <h2>待支付</h2>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div v-if="isLogin" class="order_content">
      <div v-if="orderList.length">
        <div v-for="(item, key) in orderList" :key="key" class="order_section" style="color: black">
          <yd-flexbox class="order_number">
            <yd-flexbox-item>订单信息</yd-flexbox-item>
            <yd-flexbox-item class="status_now"><span style="float: right;">{{item.status_name}}</span><span
              :class="item.status === '10' ? 'status_pay' :'status_unpay'"></span><span class="status_now2"></span>
            </yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox>
            <yd-flexbox-item style="color: #909090;">订单号</yd-flexbox-item>
            <yd-flexbox-item class="number">{{item.ordersn}}</yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox class="state_time">
            <yd-flexbox-item style="color: #909090;">下单时间：<span>{{item.updated_at}}</span></yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox class="state_time" v-if="item.countdown && item.payway !== '3' && item.payway !== '4'">
            <yd-flexbox-item style="color: #909090;">订单有效期：</yd-flexbox-item>
            <yd-flexbox-item style="color: #909090;">
              <div>
                <p class="effective_period">
                  <yd-countdown :time="item.countdown" timetype="second"></yd-countdown>
                </p>
              </div>
            </yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox v-if="item.product_type === '22'" class="ticket_text">
            <yd-flexbox-item>门票信息</yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox v-if="item.product_type === '100'" class="ticket_text">
            <yd-flexbox-item>商品信息</yd-flexbox-item>
          </yd-flexbox>
          <div v-if="item.product_type === '22'">
            <yd-flexbox direction="vertical">
              <yd-flexbox-item v-for="(p, key) in item.piao" :key="key" class="admission">
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left"><img src="../../assets/image/putongmenpiao.png" alt="">{{p.goods_name}}
                  </yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">{{p.goods_price}}</yd-flexbox-item>
                </yd-flexbox>
                <yd-flexbox class="order_name">
                  <div class="box">
                    <!-- <div class="info_box">
                      <p>参会者姓名</p>
                      <p>职务名</p>
                      <p>联系电话</p>
                      <div class="clearfix"></div>
                    </div> -->
                    <div v-for="(c, key) in p.contacts" :key="key"
                         style="width: 100%;height: .52rem;line-height: .52rem;">
                      <p><img src="../../assets/image/touxiang.png" alt="">{{c.user_name}}</p>
                      <p>{{c.user_name}}</p>
                      <p>{{c.mobile_phone}}</p>
                    </div>
                  </div>
                </yd-flexbox>
              </yd-flexbox-item>
            </yd-flexbox>
          </div>
          <div v-if="item.product_type === '29'">
            <yd-flexbox direction="vertical">
              <yd-flexbox-item v-for="(p, key) in item.room" :key="key" class="admission">
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left">酒店名称：</yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">{{p.hotelname}}</yd-flexbox-item>
                </yd-flexbox>
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left">房间类型：</yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">{{p.roomtype}}</yd-flexbox-item>
                </yd-flexbox>
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left">入住：{{p.ruzhutime}}</yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">离店：{{p.likatime}}</yd-flexbox-item>
                </yd-flexbox>
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left">共：{{p.day}} 晚</yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">数量：{{p.num}}</yd-flexbox-item>
                </yd-flexbox>
                <yd-flexbox class="order_name">
                  <div class="box">
                    <!-- <div class="info_box">
                      <p>入住人</p>
                      <P>职位名</P>
                      <p>联系方式</p>
                      <div class="clearfix"></div>
                    </div> -->
                    <div v-for="(c, key) in p.ExhRoomorderContacts" :key="key"
                         style="border-bottom: solid 1px #f2f2f2;width: 100%;height: .52rem;line-height: .52rem;">
                      <p><img src="../../assets/image/touxiang.png" alt="">{{c.exh_contacts_name}}</p>
                      <p>{{c.exh_contacts_name}}
                      <p>
                      <p>{{c.exh_contacts_phone}}</p>
                    </div>
                  </div>
                </yd-flexbox>
              </yd-flexbox-item>
            </yd-flexbox>
          </div>
          <div v-if="item.product_type === '100'">
            <yd-flexbox direction="vertical">
              <yd-flexbox-item v-for="(p, key) in item.piao" :key="key" class="admission">
                <yd-flexbox>
                  <yd-flexbox-item class="admission_left">{{p.goods_name}}</yd-flexbox-item>
                  <yd-flexbox-item class="admission_right">{{p.goods_price}}</yd-flexbox-item>
                </yd-flexbox>
              </yd-flexbox-item>
            </yd-flexbox>
          </div>
          <yd-flexbox style="padding: 0.1rem 0.4rem">
            <yd-flexbox-item style="color: #999">总价：<span class="order_amount">￥{{item.order_amount}}</span>
            </yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox style="padding: 0.1rem 0.4rem">
            <yd-flexbox-item style="color: #999">优惠：<span class="order_amount">￥{{item.coupon_amount}}</span>
            </yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox style="padding: 0.1rem 0.4rem">
            <yd-flexbox-item style="color: #666">需支付：<span class="order_amount" style="color: #c82921;">￥{{item.order_unpay}}</span>
            </yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox v-if="item.status === '-4'">
            <yd-flexbox-item>驳回原因：{{item.reason}}</yd-flexbox-item>
          </yd-flexbox>
          <yd-flexbox class="state_payment">
            <yd-flexbox-item class="left_btn_box">
              <div v-if="parseInt(item.status) >= 2 && parseInt(item.status) !== 10 && parseInt(item.status) !== 3"
                   class="cancel-box">
                <a @click="cancelOrder(item.id)" class="cancel-btn"
                   style="border-color: #d2d2d2!important;color: #999!important;">取消订单</a>
              </div>
              <a v-if="item.product_type === '22'" :href="'/' + params.id + '/meet-create'" v-show="jieji_Open"
                 style="float: left;color: #c82921!important;border-color: #c82921!important;">添加接机</a>
            </yd-flexbox-item>
            <yd-flexbox-item class="right_btn_box">
              <div v-if="parseInt(item.status) >= 2 && parseInt(item.status) !== 10">
                <a :href="'/'+params.id+'/fair-pay2/'+item.id" v-if="item.product_type === '100'"
                   style="color: #FFF!important;background-color: #c82921;border: none!important;">立即支付</a>
                <a :href="'/'+params.id+'/fair-pay/'+item.id" v-else
                   style="color: #FFF!important;background-color: #c82921;border: none!important;">立即支付</a>
              </div>
              <div v-if="parseInt(item.status) >= 1 && parseInt(item.status) !== 3">
                <a v-if="item.invo" :href="'/' + params.id + '/invoice-detail/' + item.invo.id"
                   style="border-color: #c82921!important;color: #c82921!important">查看发票</a>
                <a v-if="!item.invo" :href="'/' + params.id + '/invoice-create/' + item.id"
                   style="border-color: #c82921!important;color: #c82921!important">补开发票</a>
              </div>
            </yd-flexbox-item>
          </yd-flexbox>
        </div>
      </div>
      <div v-else>
        <div class="zwsj"><img src="../../assets/image/zanwushuju.png"></div>
      </div>
    </div>
    <div v-else style="color: red">
      <yd-tab v-model="QuickLogin">
        <yd-tab-panel label="密码登录"></yd-tab-panel>
        <yd-tab-panel label="短信登录"></yd-tab-panel>
      </yd-tab>
      <yd-cell-group>
        <yd-cell-item>
          <yd-icon slot="icon" name="phone3" size=".45rem"></yd-icon>
          <input type="text" slot="right" v-model="phone" placeholder="请输入手机号码">
        </yd-cell-item>
        <yd-cell-item v-if="QuickLogin">
          <yd-icon slot="icon" name="verifycode" size=".45rem"></yd-icon>
          <input type="text" slot="right" v-model="code" placeholder="请输入验证码">
          <yd-sendcode slot="right"
                       v-model="codeStatus"
                       storage-key="hahaha"
                       @click.native="sendCode"
                       type="warning"
          ></yd-sendcode>
        </yd-cell-item>
        <yd-cell-item v-if="!QuickLogin">
          <yd-icon slot="icon" name="verifycode" size=".45rem"></yd-icon>
          <input type="password" slot="right" v-model="password" placeholder="请输入密码">
        </yd-cell-item>
        <yd-button size="large" type="primary" @click.native="login">登录</yd-button>
      </yd-cell-group>
    </div>
  </div>
</template>

<script type="text/babel">
  import axios from 'axios'

  export default {
    name: 'Fairdetail',
    data() {
      return {
        termList: [],
        isLogin: this.$store.state.isLogin,
        phone: '',
        code: '',
        fairDetail: [],
        countNum: {
          piao: 0,
          qiandao: 0,
          order: 0
        },
        shopUrl: this.$store.state.frontend_url + '/shop/good/list?fair=' + this.$route.params.id,
        jieji_Open: false,
        password: '',
        params: this.$route.params,
        codeStatus: false,
        orderList: [],
        QuickLogin: 0,
        imgUrl: require('../../assets/image/img4.png')
      }
    },
    methods: {
      sendCode() {
        let res = this.checkFormat('phone')
        if (!res) {
          return false
        }
        this.$dialog.loading.open('发送中...')
        let data = {
          mobile: this.phone,
          type: 4,
          fair_id: this.params.id
        }
        axios
          .post('/user/send-sms', data)
          .then(this.sendSmsScc)
      },
      sendSmsScc(res) {
        res = res.data
        if (res.status) {
          this.codeStatus = true
          this.$dialog.loading.close()
          this.$dialog.toast({
            mes: '已发送'
          })
        } else {
          this.$dialog.loading.close()
          this.$dialog.toast({
            mes: '网络错误'
          })
        }
      },
      checkFormat(res) {
        if (res === 'phone') {
          if (this.phone.length !== 11) {
            this.$dialog.toast({
              mes: '请填写正确的手机号'
            })
            return false
          }
        } else if (res === 'code') {
          if (this.phone.length !== 11) {
            this.$dialog.toast({
              mes: '请填写正确的手机号'
            })
            return false
          }
          if (this.code.length <= 0) {
            this.$dialog.toast({
              mes: '请填写验证码'
            })
            return false
          }
        } else if (res === 'login') {
          if (this.phone.length !== 11) {
            this.$dialog.toast({
              mes: '请填写正确的手机号'
            })
            return false
          }
          if (this.password.length <= 0) {
            this.$dialog.toast({
              mes: '请填写密码'
            })
            return false
          }
        }
        return true
      },
      login() {
        let res = false
        let user = []
        if (this.QuickLogin) {
          res = this.checkFormat('code')
          user = {
            mobile_phone: this.phone,
            openid: '',
            fairid: this.params.id,
            unionid: '',
            code: this.code
          }
        } else {
          res = this.checkFormat('login')
          user = {
            mobile_phone: this.phone,
            openid: '',
            unionid: '',
            password: this.password
          }
        }
        if (!res) {
          return false
        }
        axios
          .post('/user/login', user)
          .then(this.loginSucc)
      },
      loginSucc(res) {
        res = res.data
        if (res.status) {
          localStorage.setItem('uid', res.data.uid)
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('name', res.data.name)
          localStorage.setItem('mobile_phone', res.data.mobile_phone)
          this.$dialog.toast({
            mes: '登录成功'
          })
          if (this.$route.query.is_shop === '1') {
            this.shopRedirect(res.data.token)
            return false
          }
          this.$router.push({path: '/' + this.$route.params.id})
        } else {
          let msg = '账号密码错误'
          if (this.QuickLogin) {
            msg = '验证码错误'
          }
          this.$dialog.toast({
            mes: msg
          })
        }
      },
      logOut() {
        localStorage.removeItem('uid')
        localStorage.removeItem('token')
        localStorage.removeItem('name')
        localStorage.removeItem('mobile_phone')
        location.reload()
      },
      HistoryBack() {
        window.history.back()
      },
      getOrder() {
        if (this.isLogin) {
          let data = {
            fair_id: this.params.id,
            uid: this.$store.state.uid
          }
          let that = this
          axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
          axios
            .post('/fair/countnum', data)
            .then(res => {
              res = res.data
              if (this.$route.query.is_shop === '1') {
                this.$dialog.loading.clone()
                this.shopRedirect(this.token)
                return false
              }
              if (res.status) {
                this.countNum = res.data
                if (res.data.headimg) {
                  this.imgUrl = res.data.headimg
                }
              }
            })
            .catch(function (res) {
              localStorage.clear()
              that.$dialog.toast({mes: '身份过期请重新登录'})
              window.location.reload()
            })
          axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
          axios
            .post('/fair/order-details', data)
            .then(res => {
              res = res.data
              if (res.status) {
                if (res.data.order != undefined) {
                  this.orderList = res.data.order
                }
              }
            })
            .catch(function (res) {
              localStorage.clear()
              that.$dialog.toast({mes: '身份过期请重新登录'})
              window.location.reload()
            })
        }
      },
      getFairDetail() {
        let data = {id: this.params.id}
        axios
          .post('/fair/fair-detail', data)
          .then(this.getFairDetailSucc)
      },
      getFairDetailSucc(res) {
        res = res.data
        if (res.status && res.data) {
          this.fairDetail = res.data.fair
        }
      },
      getJiejiSystem() {
        let data = {fairid: this.params.id, type_: 'is_jieji'}
        axios
          .post('/user/setting', data)
          .then(res => {
            res = res.data
            if (res.res === '1') {
              this.jieji_Open = true
            }
          })
      },
      addJieji() {
        this.$router.push('meet-create')
      },
      cancelOrder(oid) {
        let that = this
        let data = {uid: this.$store.state.uid, order_id: oid}
        axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
        axios
          .post('fair/cancel', data)
          .then(res => {
            res = res.data
            if (res.status) {
              this.$dialog.toast({mes: res.msg})
              this.$router.go(0)
            }
          })
          .catch(function (res) {
            localStorage.clear()
            that.$dialog.toast({mes: '身份过期请重新登录'})
            window.location.reload()
          })
      },
      updateQueryStringParameter(uri, key, value) {
        if (!value) {
          return uri
        }
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
        var separator = uri.indexOf('?') !== -1 ? '&' : '?'
        if (uri.match(re)) {
          return uri.replace(re, '$1' + key + '=' + value + '$2')
        } else {
          return uri + separator + key + '=' + value
        }
      },
      shopRedirect(token) {
        window.location.href = this.updateQueryStringParameter(this.$route.query.redirect, 't', token)
      },
      setting() {
        this.$router.push({path: '/' + this.$route.params.id + '/setting'})
      },
      memberLogin(query) {
        let that = this
        let data = query
        axios
          .post('user/member-login', data)
          .then(res => {
            res = res.data
            if (res.status) {
              this.$dialog.toast({mes: res.msg})
              localStorage.setItem('uid', res.data.uid)
              localStorage.setItem('token', res.data.token)
              localStorage.setItem('name', res.data.name)
              localStorage.setItem('mobile_phone', res.data.mobile_phone)
              this.$dialog.toast({
                mes: '登录成功'
              })
              this.$router.push({path: '/' + this.$route.params.id}, true)
              location.reload()
            } else {
              this.$dialog.toast({mes: res.msg})
              this.$router.push({path: '/' + this.$route.params.id})
            }
          })
          .catch(function (res) {
            localStorage.clear()
            that.$dialog.toast({mes: '身份过期请重新登录'})
            window.location.reload()
          })
      },
      async checkHistory() {
        let history_url = document.referrer;
        let url = window.location.host;
        if (history_url.indexOf(url) != -1) {
          let memUrl = localStorage.getItem('memUrl');
          if (memUrl) {
            window.location.href = memUrl;
          } else {
            history.go(-1);
          }
          return false;
        } else {
          localStorage.setItem('memUrl', history_url);
          return true;
        }
      }
    },
    mounted() {
      let query = this.$route.query
      if (query.is_shop === '1' && this.isLogin) {
        this.$dialog.loading.open('登录验证...')
      }
      if (!this.isLogin && query.uid && query.token && query.mobile) {
        this.memberLogin(query)
      }
      if (query.token != undefined && this.isLogin) {
        if (this.checkHistory()) {
          this.$router.push({path: '/' + this.$route.params.id})
        }
      }
      this.getFairDetail()
      this.getJiejiSystem()
      this.getOrder()
    }
  }
</script>

<style lang="stylus" scoped>
  .yd-cell-box
    margin-bottom: 0.5rem

  .order_section
    overflow: hidden
    margin-bottom: 0.4rem
    padding-bottom: .2rem
    background-color: #fff
    border-radius: .2rem

  .order_section .yd-flexbox
    padding: 0.2rem 0.4rem

  .order_section .yd-flexbox.order_number
    border-bottom: 1px solid #dcdcdc
    font-size: 0.32rem
    color: #333
    position: relative
    padding-top: .3rem
    padding-bottom: .2rem

  .number
    color: #999
    text-align: end
    font-size: .28rem

  .status_now
    color: #999
    text-align: end
    font-size: .28rem
    position: relative

  .status_pay
    width: .2rem
    height: .2rem
    background-color: #00C800
    float: right
    margin-right: .16rem
    margin-top: .1rem

  .status_unpay
    width: .2rem
    height: .2rem
    background-color: #c82921
    float: right
    margin-right: .16rem
    margin-top: .1rem

  .order_section .yd-flexbox.ticket_text
    color: #333
    padding-bottom: 0
    position: relative

  .order_section .title
    font-size: 0.32rem
    color: #00c800
    font-weight: bold
    text-align: left
    width: 100%
    overflow: hidden

  .order_section .admission .yd-flexbox
    padding-left: 0
    padding-right: 0
    color: #999
    padding-top: 0

  .order_section .admission_right
    text-align: right

  .order_name .box
    width: 90%
    overflow: hidden
    margin 0 auto

  .order_name p:first-child
    width calc(25% + .42rem)

  .order_name p:last-child
    width auto
    padding-left .12rem

  .order_name p
    width 28%
    float: left
    text-align: left

  .state_section
    font-size: 0.32rem
    color: #00c800
    font-weight: bold
    text-align: left
    width: 100%
    overflow: hidden
    position: relative
    margin-top: .2rem

  .order_section .yd-flexbox.state_section
    padding-top: 0.2rem

  .state_time
    padding-top: 0 !important
    color: #909090

  .state_time span
    float: right
    color: #909090

  .left_btn_box .yd-btn
    display: block
    float: left
    height: 0.6rem
    width: 1.56rem
    color: #909090
    border-radius: .3rem
    text-align: center
    border: solid .02rem #909090
    background-color: #fff
    box-sizing: border-box

  .left_btn_box > :first-child
  .right_btn_box > :last-child a
    margin-right: calc((200% - 6.24rem) / 3)

  .right_btn_box a
  .left_btn_box a
    display: block
    float: right
    height: 0.6rem
    width: 1.56rem
    color: #909090
    border-radius: .3rem
    text-align: center
    font-size: .24rem
    line-height: 0.6rem
    border: solid .02rem #909090
    background-color: #fff

  .order_amount
    float right

  .yd-flexview
    background: none !important

  .order_number .yd-flexbox-item
    padding: 0

  .clearfix
    clear: both

  .header_top
    // background: url(../../assets/image/single-my-bg.png)
    background none !important
    background-color #c82921 !important
    background-repeat: no-repeat
    background-size: cover
    padding-top: 1rem
    padding-bottom: .6rem
    border-bottom-left-radius: 10%
    border-bottom-right-radius: 10%

  .header p
    text-align: center
    color: #fff

  .user_name p
  .user_name button
    font-size: .24rem
    color: #fff
    line-height: .32rem
    font-family: "microsoft yahei"
    vertical-align: baseline

  .user_name
    margin-bottom: .1rem

  .head a
    color: #fff

  .head
    width: 1.8rem
    height: 1.8rem
    // background-color: #fff
    // border: solid .04rem #fff
    // border-radius: 50%
    box-sizing: border-box
    margin: 0 auto
    margin-bottom: .2rem
    text-align: center
    line-height: 1.8rem

  .head img {
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .order_status
    width: calc(100% - .4rem)
    margin: 0 auto
    margin-top: -.4rem
    margin-bottom: .2rem
    padding: .2rem 0
    background-color: #fff
    border-radius: .1rem

  .status
    width: calc(100% / 3)
    float: left
    text-align: center
    color: #666
    font-size: .32rem
    line-height: .4rem
    border-right: solid 1px #eee

  .status:nth-child(3)
    border: none

  .status p
    color: #333

  .order_number::before
    content: ""
    width: .06rem
    height: .32rem
    background-color: #c82921 !important
    position: absolute
    left: .2rem
    top: .34rem
    margin-top: .04rem

  .order_section .title
    margin-bottom: .2rem

  .effective_period
    float: right

  .order_number .payment
    float: right

  .info_box
    line-height: .52rem

  .cancel-box
    overflow hidden
    float left

  .box img
    width .36rem
    height .36rem
    float left
    margin .06rem .06rem .08rem 0

  .admission_left img
    float left
    width .36rem
    margin .06rem 0.06rem .06rem 0

  .zwsj
    text-align center
    margin-top 0.6rem
</style>



// WEBPACK FOOTER //
// src/views/template1/SingleMy.vue